export interface DictionaryMessageTypeFuelAppEntity {
  id: number | undefined;
  messageType: string;
}

